import { render, staticRenderFns } from "./SurveyEmptyComponent.vue?vue&type=template&id=70e1e625&scoped=true&"
import script from "./SurveyEmptyComponent.vue?vue&type=script&lang=js&"
export * from "./SurveyEmptyComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e1e625",
  null
  
)

export default component.exports